import { createNode, PlainDateTimeDataType, PlainDateDataType } from '@glueapp/graph-types';
import { toPlainDateTime, fromPlainDate } from '../../utils/temporal';

export const DateTimeToDate = createNode({
    id: 'DateTime to Date',
    name: 'DateTime to Date',
    description: 'Extracts the Date portion from a DateTime, discarding the time',
    aiDescription:
        'Takes a DateTime on the "DateTime" port and outputs just the Date portion on the "Date" port, discarding the time component.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        DateTime: PlainDateTimeDataType,
    },
    outPorts: {
        Date: PlainDateDataType,
    },
    execute: function (input) {
        const dateTime = toPlainDateTime(input.inPorts.DateTime);
        return { output: { Date: fromPlainDate(dateTime.toPlainDate()) } };
    },
});
